//@flow
import React from "react";
import fluxfix from "../../services/fluxfix";

//  $FlowFixMe
import css from "./statusbar.module.scss";
import { Container } from "flux/utils";
import { Actions } from "../../services/actions";
import DurationBar from "./ui-durationbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle as faPlay, faPauseCircle as faPause, faSync, faBars } from "@fortawesome/free-solid-svg-icons";
// import { SourceType } from "./source";
// import PlayerControl from '../audioplayer/playerControl'
import placeholder from "../../img/placeholder.png";
import UIVolumeControl from "./ui-volume-control";
import { isMobile } from "react-device-detect";
import { limitText } from "../../lib/limittext";
import Store from "../../services/store";

type Props = {
  station: Object,
  source: string,
  // livemetadata: Object,
};
type State = {
  store: Object,
};

class StatusBarContainer extends React.Component<Props, State> {
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { store: Store.getState() };
  }

  handleToggleShowPanel() {
    Actions.setHidePanel(!this.state.store.get("hidePanel"));
  }

  handleTogglePlay(e: SyntheticMouseEvent<*>) {
    e.stopPropagation();
    Actions.togglePlay();
  }

  componentDidUpdate() {
    const audioSource = this.state.store.get("currentSrc");
    if (!audioSource) return null;

    let t = "In Demand Radio";

    if (audioSource?.isLiveStream) {
      const { station } = this.props;
      // if (station?.nowFeature?.displayNowPlaying !== false) {
      //   t = "";
      //   t+= station?.nowSong?.artistDisplay
      //   t += " - ";
      //   t += station?.nowSong?.title
      // }else{

      if (station?.name) t = station?.name;

      if (station?.nowFeature?.name) {
        t += " - ";
        t += station?.nowFeature?.name;
      }

      // }
    } else {
      // PODCAST
      // t = audioSource.title + " - " + audioSource.description;
    }

    const words = t.split(" ");
    const wordsCapped = words.map((word) => {
      if (word) return word[0].toUpperCase() + word.substr(1);
      return word;
    });
    window.document.title = wordsCapped.join(" ");
  }

  render() {
    const { station } = this.props;
    const audioSource = this.state.store.get("currentSrc");
    if (!audioSource) return null;
    const panelIsHidden = this.state.store.get("hidePanel");
    // const isPlaying = this.state.store.get("isPlaying");
    const playState = this.state.store.get("playState");
    const currentTime = this.state.store.get("currentTime") || 0;
    const duration = this.state.store.get("duration") || 0;
    const cdivd = (currentTime / duration) * 100 || 0;
    const isLiveStream = audioSource.isLiveStream;
    // const station = stations && stations[audioSource.stationID];
    // console.log(station)
    let nowShowName = isLiveStream ? station?.nowFeature?.name || station?.name : station?.feature.name;
    let nowShowDescription = isLiveStream ? station?.nowFeature?.description || station?.shortDescription : station?.description;
    if (nowShowName === "In Demand Radio") {
      nowShowName = station?.name;
      nowShowDescription = station?.shortDescription;
    }

    let image = (isLiveStream ? station?.nowFeature?.image || station?.logoSq : station?.feature.image) || placeholder;

    const icon = playState === "BUFFERING" ? <FontAwesomeIcon icon={faSync} spin={true} /> : playState === "PLAYING" ? <FontAwesomeIcon icon={faPause} /> : <FontAwesomeIcon icon={faPlay} />;

    const hasShadow = panelIsHidden ? css.shadow : css.shadow;

    return (
      <div className={[css.statusBar, hasShadow].join(" ")}>
        {/* <DurationBar completePercent={cdivd} isLiveStream={isLiveStream} isPlaying={isPlaying} /> */}

        <div className={css.row} onClick={() => this.handleToggleShowPanel()}>
          <div className={css.statusBarImage} style={{ backgroundImage: `url(${image})` }}></div>
          <div className={css.playerControl}>
            <div className={css.icon} onClick={(e) => this.handleTogglePlay(e)}>
              {icon}
            </div>
            <div className={css.info}>
              <div className={css.title}>{limitText(nowShowName, 40)}</div>
              <div className={css.description}>{limitText(nowShowDescription, 60)}</div>
            </div>
          </div>
          <div>
            <div className={css.playerHideToggle}>
              {/* <FontAwesomeIcon icon={panelIsHidden ? faCaretSquareUp : faCaretSquareDown} /> */}
              <FontAwesomeIcon icon={faBars} />
            </div>
          </div>
        </div>
        <DurationBar completePercent={cdivd} isLiveStream={isLiveStream} isPlaying={playState === "PLAYING"} />

        <div className={css.row}>{!isMobile && <UIVolumeControl />}</div>
      </div>
    );
  }
}

export default (Container.create(fluxfix.convert(StatusBarContainer)): Object);
